import React, { useState } from "react";
import "./styles/gallery.css";

// Image imports
import img2 from "../assets/gallery-image2.jpg";
import img3 from "../assets/p2.jpg";
import img4 from "../assets/p3.jpg";
import img5 from "../assets/gallery-image5.jpg";
import img6 from "../assets/gallery-image6.jpg";
import img7 from "../assets/p7.jpg";
import img8 from "../assets/c1.jpg";
import img9 from "../assets/c2.jpg";
import img10 from "../assets/c3.jpg";
import img11 from "../assets/c4.jpg";
import img12 from "../assets/c5.jpg";
import img13 from "../assets/c6.jpg";
import img14 from "../assets/c7.jpg";
import img15 from "../assets/c9.jpg";
import img16 from "../assets/c10.jpg";
import img17 from "../assets/sus1.jpg";
import img18 from "../assets/s1.jpg";
import img19 from "../assets/s2.jpg";
import img20 from "../assets/s3.jpg";
import img21 from "../assets/s4.jpg";
import img22 from "../assets/r8.jpg";
import img23 from "../assets/p3.jpg";
import img24 from "../assets/about2.jpg";
import img25 from "../assets/banner2.jpg";
import img26 from "../assets/black car.jpg";
import img27 from "../assets/boutus.jpg";
import img28 from "../assets/tut.jpg";
import img29 from "../assets/tut2.jpg";

// Video imports
import video1 from "../assets/banner-video.mp4";
import video2 from "../assets/banner7.mp4";
import video3 from "../assets/for banner.mp4";
import video4 from "../assets/r8.mp4";
import video5 from "../assets/tut.mp4";
import video6 from "../assets/vid.mp4";
import video7 from "../assets/vid2.mp4";
import video8 from "../assets/vid1.mp4";
import video9 from "../assets/vid3.mp4";
import video10 from "../assets/banner-video.mp4";
import video11 from "../assets/vid4.mp4";
import video12 from "../assets/vid5.mp4";
import video13 from "../assets/vid6.mp4";
import video14 from "../assets/vid7.mp4";
import video15 from "../assets/video.mp4";
import video16 from "../assets/x.mp4";
import video17 from "../assets/xx.mp4";
import video18 from "../assets/xxx.mp4";
import video19 from "../assets/xxxx.mp4";
import video20 from "../assets/xxxxx.mp4";
import video21 from "../assets/xxxxxx.mp4";

const images = [
  { src: video1, category: "Video", type: "video" },
  { src: video2, category: "Video", type: "video" },
  { src: video3, category: "Video", type: "video" },
  { src: video4, category: "Video", type: "video" },
  { src: video5, category: "Video", type: "video" },
  { src: video6, category: "Video", type: "video" },
  { src: video7, category: "Video", type: "video" },
  { src: video8, category: "Video", type: "video" },
  { src: video9, category: "Video", type: "video" },
  { src: video10, category: "Video", type: "video" },
  { src: video11, category: "Video", type: "video" },
  { src: video12, category: "Video", type: "video" },
  { src: video13, category: "Video", type: "video" },
  { src: video14, category: "Video", type: "video" },
  { src: video15, category: "Video", type: "video" },
  { src: video16, category: "Video", type: "video" },
  { src: video17, category: "Video", type: "video" },
  { src: video18, category: "Video", type: "video" },
  { src: video19, category: "Video", type: "video" },
  { src: video20, category: "Video", type: "video" },
  { src: video21, category: "Video", type: "video" },

  { src: img2, category: "Custom", type: "image" },
  { src: img3, category: "Suspension", type: "image" },
  { src: img4, category: "Suspension", type: "image" },
  { src: img5, category: "Suspension", type: "image" },
  { src: img6, category: "Custom", type: "image" },
  { src: img7, category: "Custom", type: "image" },
  { src: img8, category: "Custom", type: "image" },
  { src: img9, category: "Custom", type: "image" },
  { src: img10, category: "Custom", type: "image" },
  { src: img11, category: "Suspension", type: "image" },
  { src: img12, category: "Custom", type: "image" },
  { src: img13, category: "Custom", type: "image" },
  { src: img14, category: "Suspension", type: "image" },
  { src: img15, category: "Custom", type: "image" },
  { src: img16, category: "Sound", type: "image" },
  { src: img17, category: "Suspension", type: "image" },
  { src: img18, category: "Sound", type: "image" },
  { src: img19, category: "Sound", type: "image" },
  { src: img20, category: "Sound", type: "image" },
  { src: img21, category: "Custom", type: "image" },
  { src: img22, category: "Custom", type: "image" },
  { src: img23, category: "Suspension", type: "image" },
  { src: img24, category: "Suspension", type: "image" },
  { src: img25, category: "Suspension", type: "image" },
  { src: img26, category: "Suspension", type: "image" },
  { src: img27, category: "Suspension", type: "image" },
  { src: img28, category: "Suspension", type: "image" },
  { src: img29, category: "Suspension", type: "image" },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState("All");

  const filteredImages =
    filter === "All" ? images : images.filter((img) => img.category === filter);

  const categories = ["All", "Suspension", "Video", "Sound", "Custom"];

  return (
    <section id="gallery" className="gallery-section">
      <br />
      <h2>Our Work</h2>

      {/* Filter Buttons */}
      <div className="gallery-filters">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setFilter(cat)}
            className={filter === cat ? "active" : ""}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid">
        {filteredImages.map((img, index) => (
          <div
            className="gallery-card"
            key={index}
            onClick={() => setSelectedImage({ src: img.src, type: img.type })}
          >
            {img.type === "video" ? (
              <video
                src={img.src}
                width="100%"
                height="100%"
                muted
                loop
                playsInline
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
                style={{ objectFit: "cover" }}
              />
            ) : (
              <img
                src={img.src}
                alt={`Work ${index + 1}`}
                onContextMenu={(e) => e.preventDefault()}
              />
            )}
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button
            className="lightbox-close"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
          >
            &times;
          </button>

          {selectedImage.type === "video" ? (
            <video
              controls
              autoPlay
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
              style={{ maxWidth: "90%", maxHeight: "80%" }}
            >
              <source src={selectedImage.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={selectedImage.src}
              alt="Enlarged view"
              onContextMenu={(e) => e.preventDefault()}
            />
          )}
        </div>
      )}
    </section>
  );
};

export default Gallery;
